
import {initWebComponent} from "@/helpers/web-component-helper";
import {WizardBodyComponent} from "@/components/wizard/wizard-body-component";
import {initDependentFields} from "@/helpers/form-dependent-helper";

const template = document.createElement('template');

export class WizardTabComponent extends HTMLElement {
    constructor() {
        super();

        let innerHtml = ''

        innerHtml += `<div class="tab-content" style="overflow-y: auto">`
        innerHtml += `<div id="" class="d-block d-md-none"><h1 class="text-primary" id="divPageName"></h1></div>`
        innerHtml += `<!--<div class="tab-content">-->`

        const length = window.wizard.Items.length

        window.wizard.Items.map( (item, key) => {
            innerHtml += `
            <div id="step-` + key + `" class="tab-pane" style="padding: 0" role="tabpanel" aria-labelledby="step-` + key + `">
               `

            if(key === (length - 1)) {
                innerHtml += '<div class="card">'
            }

            innerHtml += `<wizard-body data-key="` + key + `"></wizard-body>`

            if(key === (length - 1)) {
                innerHtml += '</div>'
                innerHtml += '     <div class="form-group">\n                ' +
                    '<wizard-send-button></wizard-send-button>' +
                    '          </div>'
            }

            innerHtml += `
        </div>`
        })

        innerHtml += `</div>`;

        template.innerHTML = innerHtml

        initWebComponent(this, template)

        initDependentFields()
    }
}

window.customElements.define("wizard-body", WizardBodyComponent);
